import { createAction, props } from '@ngrx/store';

import { Delivery } from '../../../../../../core/models';

const ACTION_KEY = '[Favorite button]';

export const removeFavorite = createAction(
  `${ACTION_KEY} Remove favorite`,
  props<{ deliveryKeyCode: string }>(),
);

export const removeFavoriteSuccess = createAction(
  `${ACTION_KEY} Remove favorite success`,
  props<{ deliveryKeyCode: string }>(),
);

export const removeFavoriteFail = createAction(`${ACTION_KEY} Remove favorite fail`);

export const addToFavorite = createAction(
  `${ACTION_KEY} Add to favorite State`,
  props<{ delivery: Delivery }>(),
);

export const addToFavoriteSuccess = createAction(
  `${ACTION_KEY} Add to favorite State success`,
  props<{ delivery: Delivery }>(),
);

export const addToFavoriteFail = createAction(`${ACTION_KEY} Add to favorite State fail`);
